import React from "react";

import { useQuery } from "@apollo/client";
import { CasesSendReportHeaderSummaryContainerArchivedSendReportCaseSummaryDocument } from "../../../../../../generated";
import { CaseInfoHeaderFields, CaseInfoHeader } from "../../../../../shared/case-info-header/case-info-header";
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";

interface HeaderSummaryContainerProps {
  caseId: string;
}

export const HeaderSummaryContainer: React.FC<HeaderSummaryContainerProps> = (
  props
) => {
  const {
    data: applicantDetailData,
    loading: applicantDetailLoading,
    error: applicantDetailError,
  } = useQuery(
    CasesSendReportHeaderSummaryContainerArchivedSendReportCaseSummaryDocument,
    {
      variables: {
        archivedSendReportCaseSummaryId: props.caseId,
      },
    }
  );

  const caseInfoData: CaseInfoHeaderFields = {
    applicant: {
      displayName:
        applicantDetailData?.archivedSendReportCaseSummary
          ?.applicant?.displayName ?? "",
      id:
        applicantDetailData?.archivedSendReportCaseSummary
          ?.applicant?.id ?? "",
    },
    submittedAt:
      applicantDetailData?.archivedSendReportCaseSummary
        ?.submittedAt ?? "",
    lastActivityAt:
      applicantDetailData?.archivedSendReportCaseSummary
        ?.lastActivityAt ?? "",
    id: applicantDetailData?.archivedSendReportCaseSummary?.id,
  };

  return (
    <ComponentQueryLoader
      loading={applicantDetailLoading}
      hasData={applicantDetailData}
      error={applicantDetailError}
      hasDataComponent={<CaseInfoHeader data={caseInfoData} caseType="sendReport" />}
    />
  );
};

